import { createStore } from '@'

export const $googleStatus = createStore('login:google:status')
